export default `float s=2.5, e;
    p=abs(mod(p-1.,2.)-1.)-1.;
    for(int j=0;j++<10;)
      p=1.-abs(p-1.),
      s*=e=-1.8/dot(p,p),
      p=p*e-.7;
    return abs(p.z)/s+.001;
  }`